<p-confirmDialog [style]="dialogStyle()">
  <ng-template pTemplate="message" let-confirmation>
    @if (confirmation.icon) {
      <i [class]="'p-confirmdialog-icon ' + confirmation.icon"></i>
    }
    <span class="p-confirmdialog-message">{{ confirmation.message }}</span>
  </ng-template>
</p-confirmDialog>
